import { BRAND_LOGO_PUBLIC_PATH } from '../config/branding';

/**
 * Image URL utility - local storage paths only.
 * Paths starting with / are kept relative so the browser requests same-origin (fixes profile image on www vs non-www).
 */
export function getImageUrl(path: string | undefined | null): string {
  if (!path) return BRAND_LOGO_PUBLIC_PATH;
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  // Preview images from FileReader come as data/blob URLs; keep them as-is.
  if (path.startsWith('data:') || path.startsWith('blob:')) return path;
  // Same-origin: use path as-is so /uploads/users/... loads from current origin (openauction24.com or www)
  if (path.startsWith('/')) return path;
  return `/${path}`;
}
